module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": "Which teachers accounts do you want to import to Parlay?",
      "size": 'xl',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('body', {
    staticClass: "px-7 pt-7 flex-grow overflow-y-auto"
  }, [_c('div', {
    staticClass: "sub-header"
  }, [_vm._v("\n      After Signing in to Parlay, teachers will be able to roster students\n      from their LMS / SIS directly to their Parlay classroom.\n    ")]), _vm._v(" "), (_vm.teachers) ? _c('div', {
    staticClass: "mt-4"
  }, [(_vm.loading_data) ? _c('div', {
    staticClass: "flex items-center justify-center h-full"
  }, [_c('pl-spinner', {
    staticClass: "x2"
  })], 1) : _c('div', [_c('integrations-teachers-filters-bar', {
    staticClass: "mb-4",
    attrs: {
      "teachersFilters": _vm.teachersFilters
    },
    on: {
      "filters": _vm.filters,
      "admin-portal-filter-changed": _vm.resetFilters
    }
  }), _vm._v(" "), (_vm.teachers.length) ? _c('table', {
    staticClass: "teachers-table w-full h-full"
  }, [_c('thead', [_c('tr', {
    staticClass: "row no-margin middle-xs"
  }, [_c('td', {
    staticClass: "col-xs-1",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('pl-checkbox', {
    staticClass: "col-xs-1",
    on: {
      "change": function($event) {
        return _vm.handleSelectAll($event)
      }
    },
    model: {
      value: (_vm.allSelected),
      callback: function($$v) {
        _vm.allSelected = $$v
      },
      expression: "allSelected"
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2"
  }, [_vm._v("First Name")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2"
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-3"
  }, [_vm._v("Email")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-1"
  }, [_vm._v("Grade")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-2"
  }, [_vm._v("School Site")]), _vm._v(" "), _c('td', {
    staticClass: "col-xs-1"
  }, [_vm._v("Existing Parlay Account ?")])])]), _vm._v(" "), _c('tbody', {
    attrs: {
      "id": "integrations-teacher-modal"
    },
    on: {
      "scroll": function($event) {
        return _vm.$emit('scroll-on-table')
      }
    }
  }, _vm._l((_vm.teachers), function(t, index) {
    return _c('tr', {
      key: index,
      staticClass: "row no-margin"
    }, [_c('td', {
      staticClass: "col-xs-1"
    }, [_c('pl-checkbox', {
      staticClass: "col-xs-1",
      on: {
        "change": function($event) {
          return _vm.handleSelectTeacher($event, index)
        }
      },
      model: {
        value: (_vm.selectedTeachers[index]),
        callback: function($$v) {
          _vm.$set(_vm.selectedTeachers, index, $$v)
        },
        expression: "selectedTeachers[index]"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "col-xs-2 truncate",
      attrs: {
        "title": t.first_name
      }
    }, [_vm._v("\n                " + _vm._s(t.first_name) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-2 truncate",
      attrs: {
        "title": t.last_name
      }
    }, [_vm._v("\n                " + _vm._s(t.last_name) + "\n              ")]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-3"
    }, [(t.email) ? _c('div', {
      staticClass: "truncate",
      attrs: {
        "title": t.email
      }
    }, [_vm._v("\n                  " + _vm._s(t.email) + "\n                ")]) : _c('div', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-1"
    }, [(t.grades && t.grades.length) ? _c('div', _vm._l((t.grades), function(grade, index) {
      return _c('div', {
        key: index,
        staticClass: "truncate",
        attrs: {
          "title": grade
        }
      }, [_vm._v("\n                    " + _vm._s(grade) + "\n                  ")])
    }), 0) : _c('div', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-2"
    }, [(t.school_site) ? _c('div', {
      staticClass: "truncate",
      attrs: {
        "title": t.school_site
      }
    }, [_vm._v("\n                  " + _vm._s(t.school_site) + "\n                ")]) : _c('div', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      staticClass: "col-xs-1 flex justify-center"
    }, [(t.parlay_account) ? _c('div', {
      staticClass: "text-green-600"
    }, [_c('i', {
      staticClass: "fa-solid fa-check text-base leading-4"
    })]) : _c('div', {
      staticClass: "text-red-600"
    }, [_c('i', {
      staticClass: "fa fa-times text-base leading-4",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])
  }), 0)]) : _c('div', {
    staticClass: "row middle-xs center-xs no-teachers-text ph5"
  }, [_vm._v("\n          Parlay has not received any user information from this integration\n          yet. If you recently enabled the integration, it can take up to 24\n          hours for the data to propagate.\n        ")])], 1)]) : _vm._e()]), _vm._v(" "), _c('footer', {
    staticClass: "mb-7 mt-4 flex justify-center items-center"
  }, [(_vm.loading) ? _c('pl-spinner', {
    staticClass: "x2",
    staticStyle: {
      "margin": "auto"
    }
  }) : _c('button', {
    staticClass: "px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold disabled:opacity-50",
    attrs: {
      "disabled": (_vm.teachers && !_vm.teachers.length) || !_vm.selected_teachers.length
    },
    on: {
      "click": _vm.importTeachers
    }
  }, [_vm._v("\n      Import teachers to Parlay\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-e5d9b0f2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/admin/adminPortal/integrations/integrationsTeachersModal.vue
// module id = 2125
// module chunks = 61